import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { ChevronRight } from "@/assets/icons/icons";
import { FocusRing } from "@/components/Layout/BaseLayouts/Footer/FocusRing";

/**
 * A standalone external link styled as an inverted NavItem (xl size) with a
 * chevron-right icon. Used in the footer top row alongside the collapsible menus.
 */
export const SupportLinkItem = () => {
  const { t } = useTranslation();

  return (
    <a
      aria-label={t("Common.support")}
      href={t("Footer.support.url")}
      target="_blank"
      rel="noreferrer"
      className={clsx(
        "group relative inline-flex h-9 w-fit items-center gap-2 rounded-md p-1",
        "text-lg font-semibold text-foreground-primary-inverse",
        "hover:bg-surface-secondary-inverse active:bg-surface-secondary-inverse",
        "focus:outline-none",
      )}
    >
      <span className="whitespace-nowrap">{t("Common.support")}</span>
      <ChevronRight className="shrink-0" />
      <FocusRing inverted />
    </a>
  );
};
